export default __webpack_public_path__ + "static/media/alb-color.00ee8e4d.svg";